import { useCreateAnnotationNote } from '../hooks/useCreateAnnotationNote'
import styles from './ControlSheetNotes.module.scss'
import ControlSheetTextEntry from './ControlSheetTextEntry'
import { ControlSheetAnnotation, ControlSheetNote } from '../types/types'
import { noteMapper } from '../helpers/noteUtils'
import { ControlSheetDeleteButton } from './ControlSheetDeleteButton'
import { useDeleteAnnotationNote } from '../hooks/useDeleteAnnotationNote'
import { ControlSheetNoteView } from './ControlSheetNoteView'

interface Props {
    createAnnotation: () => Promise<ControlSheetAnnotation | undefined>
    annotationId?: string
    existingNotes: ControlSheetNote[]
    addTempNote: (note: ControlSheetNote) => void
    deleteTempNote: (noteId: string) => void
    addTempAnnotation: (annotation: ControlSheetAnnotation) => void
    onUpdate: () => void
    isAnnotationPending?: boolean
}

export const ControlSheetNotes = ({
    annotationId,
    createAnnotation,
    existingNotes,
    addTempNote,
    deleteTempNote,
    addTempAnnotation,
    onUpdate,
    isAnnotationPending = false,
}: Props) => {
    const { handleDeleteAnnotationNoteAsync } = useDeleteAnnotationNote()

    const {
        handleCreateAnnotationNoteAsync,
        // isPending: isCreateNotePending,
        // data: noteData,
        // error: noteError,
    } = useCreateAnnotationNote()

    return (
        <div className={styles.notesContainer}>
            <span className={styles.notesHeader}>Notes</span>
            <ControlSheetTextEntry
                submitDisabled={isAnnotationPending}
                disabled={existingNotes.length >= 5}
                placeholder="Add note (optional)"
                onSubmit={async (note) => {
                    try {
                        if (!annotationId) {
                            const newAnnotation = await createAnnotation()
                            if (newAnnotation?.id) {
                                addTempAnnotation(newAnnotation)

                                const noteResp = await handleCreateAnnotationNoteAsync(note, newAnnotation.id)
                                if (noteResp.id) {
                                    const newNote = noteMapper(newAnnotation.id)(noteResp)
                                    addTempNote(newNote)
                                    // onUpdate()
                                }
                            }
                        } else {
                            const noteResp = await handleCreateAnnotationNoteAsync(note, annotationId)
                            if (noteResp.id) {
                                const newNote = noteMapper(annotationId)(noteResp)
                                addTempNote(newNote)
                            }
                        }
                    } catch (error) {
                        console.error('Error creating annotation:', error)
                    }
                }}
            />

            {existingNotes.map((note) => (
                <div key={note.id} className={styles.noteWidgetContainer}>
                    <ControlSheetNoteView note={note} />
                    <div>
                        <ControlSheetDeleteButton
                            deleteAction={async () => {
                                try {
                                    // Call the API to delete the note
                                    // await handleDeleteAnnotationNoteAsync(note.id)
                                    // setNewNotes((prevNotes) => prevNotes.filter((n) => n.id !== note.id))
                                    const deleteResp = await handleDeleteAnnotationNoteAsync(note.id)
                                    if (deleteResp) {
                                        // setNewNotes((prevNotes) => prevNotes.filter((n) => n.id !== note.id))
                                        deleteTempNote(note.id)
                                        onUpdate()
                                    }
                                } catch (error) {
                                    console.error('Error deleting note:', error)
                                }
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}
